module.exports = __webpack_public_path__ + "assets1783936157458/img/logo-duolian.9a9f93d2.png";